import {create} from "zustand";

export type StoreState = {
    opened: boolean;
    filterKey: string | null;

    actions: {
        openModal: (filterKey: string | null) => void;
        closeModal: () => void;
    };
};

export const store = create<StoreState>((set) => ({
    opened: false,
    filterKey: null,

    actions: {
        openModal: (filterKey) => set({opened: true, filterKey}),
        closeModal: () => set({opened: false, filterKey: null}),
    },
}));
